angular.module("vgresiduos").factory("locationService", [
	"$http",
	"$q",
	"localStorageWithTimeoutService",
	function ($http, $q, localStorageWithTimeoutService) {
		"use strict";

		const countriesCacheKey = Vgr.constants.cacheKeysPrefix.countries;
		const cacheTimeoutInMinutes = 43200;

		const _listCountries = function (dto) {
			return Vgr.util.getWithCache(
				Vgr.constants.coreHostUrl + Vgr.resources.core.countries,
				dto,
				countriesCacheKey,
				cacheTimeoutInMinutes,
				localStorageWithTimeoutService,
				$http,
				$q
			);
		};

		const _listCities = function (dto) {
			const citiesUrl = Vgr.constants.coreHostUrl + Vgr.resources.core.cities;
			const parameters = Vgr.util.serializeObjectToQueryString(dto);
			const req = {
				method: "get",
				url: citiesUrl + parameters
			};
			return $http(req);
		};

		return {
			listCities: _listCities,
			listCountries: _listCountries
		};
	}
]);
